import { render } from "./Download.vue?vue&type=template&id=ca6895de"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\sistema-denuncias\\public\\apps\\presos-politicos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__